enum EnumSentFaxStatus {
    InProgress = 100,
    Sent = 101,
    Failed = 102,
    SendingEmail = 103,
    NoAnswer = 104,
    Busy = 105,
    NoRemoteFax = 106,
    NotSent = 107,
    Queued = 108
}

export { EnumSentFaxStatus };
